/**
 * Target version for version comparison
 */
export enum ETargetVersion {
  SOURCE = 'source',
  TARGET = 'target',
}

/**
 * Document comparison status
 */
export enum EDocumentComparisonStatus {
  COMPARED = 'compared',
  COMPARING = 'comparing',
  FAILED = 'failed',
}

/**
 * Document comparison change type
 */
export enum EDocumentComparisonChangeType {
  INSERT = 'insert',
  DELETE = 'delete',
  REPLACE = 'replace',
}

/**
 * Default page for version comparison
 */
export const VERSION_COMPARISON_DEFAULT_PAGE = 1

/**
 * Default zoom scale for version comparison
 */
export const VERSION_COMPARISON_ZOOM_DEFAULT = 1

/**
 * Content wrapper class name for version comparison
 */
export const CONTENT_WRAPPER_CLASS_NAME = 'content-wrapper'

/**
 * Content wrapper id for version comparison
 */
export const CONTENT_WRAPPER_ID = 'version-comparison-content-wrapper'

/**
 * Signed blob structured url refetch interval
 */
export const SIGNED_BLOB_STRUCTURED_URL_REFETCH_INTERVAL = 5000

/**
 * Custom event name for scroll to highlight
 */
export const CUSTOM_EVENT_SCROLL_TO_HIGHLIGHT = 'scroll-to-highlight'

/**
 * Custom event name for highlight click
 */
export const CUSTOM_EVENT_HIGHLIGHT_CLICK = 'highlight-click'

/**
 * CSS class name for highlighting the currently focused change
 */
export const FOCUSED_HIGHLIGHT_CLASS_NAME = 'focused-highlight'

/**
 * CSS content for highlighting the currently focused change
 */
export const FOCUSED_HIGHLIGHT_CONTENT = `
  .${FOCUSED_HIGHLIGHT_CLASS_NAME} {
    outline: 2px solid #2563EB;
    border-radius: 2px;
    z-index: 1;
  }
`
